/*
  Talg-landingssiden, delt klientlogikk.

  Fire jobber:
    1. Bruksmatrisen i familien-seksjonen. Filtrerer med opacity og ramme,
       aldri med layout-endring.
    2. Kjoepsknappen. Legger i kurven med fetch og melder fra til Horizons
       handlekurv-ikon. Brukes fra produktkort-snippeten, som staar i
       familien og inne i veiviser-modalen.
    3. E-post-hooks. Varsle meg paa utsolgte produkter, og send-svaret-feltet
       i veiviseren. Samme kall, samme kvitteringsregel.
    4. Scroll-koreografien (K6). Én delt mekanisme for hele flaten, aldri
       seksjonsvis. Defaulten er SNUDD: innhold er synlig, og JS skjuler kun
       det som er bekreftet under folden. Les kommentaren over modulen foer du
       roerer den.

  VEIVISEREN BOR IKKE HER. Den var en steg-maskin i heroen i runde 1. Fra
  runde 2 er den en modal i `sections/skm-v2-talg-quiz.liquid`, som eier all
  sin egen JS under navnerommet `data-skm-vv-*`. Steg-maskinen som sto her er
  fjernet 2026-08-25, sammen med `data-skm-talg-rull`, som ingen seksjon
  lenger sender ut. Ikke ta den tilbake uten aa flytte modalen ogsaa.

  ALLE LYTTERE ER DELEGERT paa document. Theme Editor og theme dev bytter
  seksjons-DOM mange ganger i en oekt, og lyttere bundet paa enkeltnoder doer
  med de gamle nodene. Delegeringen er ogsaa grunnen til at kjoepsknappen og
  e-postfeltet virker inne i en <dialog> i top layer uten et eneste tillegg.

  INGEN KVITTERING UTEN ET FAKTISK KALL. Statusteksten settes foerst naar
  fetch-en har svart. Staar endepunktet tomt, er feltet deaktivert fra Liquid
  og JS-en roerer det ikke.

  ALL SYNLIG TEKST KOMMER FRA LIQUID via data-attributter. Filen inneholder
  ingen redaksjonell kopi som copy-passet ikke kan naa.
*/

(function () {
  if (window.__skmTalgFlate) return;
  window.__skmTalgFlate = true;

  /* =========================================================
     Sma hjelpere
     ========================================================= */

  function liste(verdi) {
    return String(verdi || '')
      .split(',')
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);
  }

  function settStatus(node, tekst, tone) {
    if (!node) return;
    node.textContent = tekst || '';
    if (tone) {
      node.setAttribute('data-tone', tone);
    } else {
      node.removeAttribute('data-tone');
    }
    if (tekst) {
      node.setAttribute('data-synlig', 'ja');
    } else {
      node.removeAttribute('data-synlig');
    }
  }

  function gyldigEpost(verdi) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(verdi || '').trim());
  }

  /* =========================================================
     1. Bruksmatrisen
     ========================================================= */

  function filtrer(rot, verdi) {
    var antall = 0;

    rot.setAttribute('data-aktivt-filter', verdi);

    rot.querySelectorAll('[data-skm-talg-filter]').forEach(function (c) {
      var paa = c.getAttribute('data-skm-talg-filter') === verdi;
      c.setAttribute('aria-pressed', paa ? 'true' : 'false');
    });

    rot.querySelectorAll('[data-skm-talg-rute]').forEach(function (rute) {
      var kort = rute.querySelector('[data-skm-talg-merker]');
      var merker = kort ? liste(kort.getAttribute('data-skm-talg-merker')) : [];
      var treff = verdi === 'alle' || merker.indexOf(verdi) !== -1;
      rute.setAttribute('data-treff', treff ? 'ja' : 'nei');
      if (treff) antall += 1;
    });

    var melding = rot.querySelector('[data-skm-talg-filterstatus]');
    if (melding) {
      var mal = melding.getAttribute('data-mal') || '';
      melding.textContent = mal.replace('{antall}', String(antall));
    }
  }

  /* =========================================================
     2. Kjoepsknappen
     ========================================================= */

  function meldKurv(kurv) {
    if (!kurv) return;
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: kurv,
          sourceId: 'skm-v2-talg',
          data: { itemCount: kurv.item_count, source: 'skm-v2-talg' }
        }
      })
    );
  }

  function leggIKurv(form) {
    var knapp = form.querySelector('button[type="submit"]');
    var tekst = form.querySelector('[data-skm-talg-kjop-tekst]');
    var status = form.querySelector('[data-skm-talg-kjop-status]');
    if (!knapp || knapp.getAttribute('data-tilstand') === 'jobber') return;

    var original = tekst ? tekst.textContent : '';
    knapp.setAttribute('data-tilstand', 'jobber');
    knapp.disabled = true;
    settStatus(status, '', null);

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (kurv) {
        knapp.disabled = false;
        knapp.setAttribute('data-tilstand', 'lagt-i');
        if (tekst) tekst.textContent = form.getAttribute('data-tekst-lagt') || original;

        if (status) {
          var lenke = document.createElement('a');
          lenke.href = '/cart';
          lenke.textContent = form.getAttribute('data-tekst-kurv') || '/cart';
          status.textContent = '';
          status.appendChild(lenke);
          status.setAttribute('data-synlig', 'ja');
          status.removeAttribute('data-tone');
        }

        meldKurv(kurv);

        window.setTimeout(function () {
          if (!form.isConnected) return;
          knapp.removeAttribute('data-tilstand');
          if (tekst) tekst.textContent = original;
        }, 6000);
      })
      .catch(function () {
        knapp.disabled = false;
        knapp.removeAttribute('data-tilstand');
        settStatus(status, form.getAttribute('data-tekst-feil') || '', 'feil');
      });
  }

  /* =========================================================
     3. E-post-hooks, varsle meg og send svaret
     ========================================================= */

  function sendEpost(form) {
    var endepunkt = form.getAttribute('data-endepunkt');
    var felt = form.querySelector('input[type="email"]');
    var knapp = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-skm-talg-varsle-status], [data-skm-talg-epost-status]');
    if (!endepunkt || !felt) return;

    var adresse = felt.value.trim();
    if (!gyldigEpost(adresse)) {
      felt.setAttribute('aria-invalid', 'true');
      settStatus(status, form.getAttribute('data-tekst-ugyldig') || '', 'feil');
      felt.focus();
      return;
    }
    felt.removeAttribute('aria-invalid');

    if (knapp) knapp.disabled = true;
    settStatus(status, '', null);

    fetch(endepunkt, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        epost: adresse,
        liste: form.getAttribute('data-liste') || '',
        produkt: form.getAttribute('data-produkt') || '',
        produkt_tittel: form.getAttribute('data-tittel') || '',
        kilde: 'talg-lp',
        sti: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('post');
        // Kvitteringen settes foerst naa, etter et faktisk svar.
        settStatus(status, form.getAttribute('data-tekst-ok') || '', 'ok');
        felt.value = '';
        felt.disabled = true;
      })
      .catch(function () {
        if (knapp) knapp.disabled = false;
        settStatus(status, form.getAttribute('data-tekst-feil') || '', 'feil');
      });
  }

  /* =========================================================
     4. Scroll-koreografien (K6)

     Kontrakt: docs/ux/talg-k6-koreografi.md. Tall: designsystemets
     tokens.md, brikke K6. Begge er lest, og der de spriker vinner
     systemregelen, unntatt der talg-kontrakten har en MAALT grunn.

     SNUDD DEFAULT, OG HVORFOR DET ER HELE POENGET.
     Den gamle modellen var «alt er skjult, avsloer det som krysser». Da er
     hvert hull i logikken en usynlig kjoepsvei.

     Aarsaken var IKKE at IntersectionObserver «rapporterer
     tilstandsendringer, ikke tilstand». MDN, verifisert 2026-08-25:
     den initielle runden FYRER per observert element, ogsaa med
     `isIntersecting: false`. Den ekte feilen var at koden bare la paa
     avsloeringsklassen naar `isIntersecting` var sann, mens hele flaten laa
     OVER viewporten etter hoppet. Leseren rullet videre ned, elementene kom
     aldri inn igjen, og ble liggende skjult for alltid.

     Derfor: CSS-default er SYNLIG. Denne modulen legger paa skjul-tilstand
     KUN paa grupper den foerste runden bekrefter ligger UNDER folden. Tre av
     fire utfall i klassifiseringen ender i «vis». Enhver tvil, hver bug,
     hvert nettleseravvik, JS som kaster, JS slaatt av og reduced-motion
     ender med SYNLIG innhold. Feilklassen forsvinner i stedet for aa lappes.

     ROTEN ANIMERER ALDRI. Gruppa er den observerte enheten, medlemmene er
     det som beveger seg. Det gjoer K6-regelen «hold det moerke baandet
     stille» til en arkitektonisk egenskap i stedet for disiplin:
     `section.skm-talg-opph` kan baere gruppa uten at furubakgrunnen noen
     gang faar `opacity`. Samme sak for foto kant-til-kant.

     TERSKELEN HAR ET GULV, OG UTEN DET VILLE ROSTEREN VAERT USYNLIG.
     `threshold: 0.15` er ikke naabar for et element som er mye hoeyere enn
     viewporten: maks mulig ratio er rotHoeyde/elementHoeyde. Bruksmatrisen
     er ~4700px med sju kort i én kolonne; paa en 700px skjerm med
     `rootMargin -8%` blir effektiv rothoeyde 644px og maks ratio 0,13. Da
     ville de sju tyngste kjoepsveiene paa flaten aldri blitt avsloert.
     Vakten under degraderer til «enhver kryssing» der 0,15 ikke kan naas.

     MODULEN SLETTER SITT EGET FOTAVTRYKK. `data-avslor` fjernes ~900ms
     etter avsloering (420ms + fire stagger-steg + slack). To grunner. Den
     kosmetiske: transisjonen ville ellers ligget permanent og overstyrt
     elementets EGNE transisjoner, for eksempel `border-color` paa
     matrise-rutene. Den baerende: etter ett sekund finnes ingen tilstand
     igjen som en senere feil kan gjenopplive. `setTimeout` og ikke `rAF`,
     fordi timere fyrer ogsaa i strupte faner.
     ========================================================= */

  var REVEAL_TERSKEL = 0.15;
  var REVEAL_MARGIN = '0px 0px -8% 0px';
  var REVEAL_RYDD_MS = 900;

  var revealIO = null;

  function revealMedlemmer(rot) {
    var ut = [];
    rot.querySelectorAll('[data-skm-talg-reveal]').forEach(function (el) {
      // Et medlem hoerer til den NAERMESTE gruppa. Da kan grupper noestes
      // uten at et element skjules to ganger.
      if (el.closest('[data-skm-talg-reveal-gruppe]') === rot) ut.push(el);
    });
    return ut;
  }

  function revealSkjul(rot) {
    rot.setAttribute('data-avslor-tilstand', 'skjult');
    revealMedlemmer(rot).forEach(function (el) {
      el.setAttribute('data-avslor', 'skjult');
    });
  }

  function revealVis(rot, animer) {
    rot.setAttribute('data-avslor-tilstand', 'inn');
    var medlemmer = revealMedlemmer(rot);
    if (!animer) {
      // Ingen saa skjulingen, saa ingen skal se en animasjon heller. Aa
      // fjerne attributtet snapper rett til synlig, fordi `[data-skm-talg-reveal]`
      // alene ikke har noen regel.
      medlemmer.forEach(function (el) {
        el.removeAttribute('data-avslor');
      });
      return;
    }
    medlemmer.forEach(function (el) {
      el.setAttribute('data-avslor', 'inn');
    });
    window.setTimeout(function () {
      medlemmer.forEach(function (el) {
        el.removeAttribute('data-avslor');
      });
    }, REVEAL_RYDD_MS);
  }

  function revealKlassifiser(entry) {
    var b = entry.boundingClientRect;
    var r = entry.rootBounds;

    // 1. Noe av gruppa er synlig. Da skjuler vi ingenting, uansett ratio.
    if (entry.isIntersecting) return 'vis';

    // 2. Ingen geometri aa doemme etter. Skjer ved kryssopprinnelses-rot.
    //    Ikke vaart tilfelle, men testen skal taale det.
    if (!r) return 'vis';

    // 3. Allerede rullet forbi: hele gruppa ligger over rotens topp.
    //    Den skal ALDRI skjules.
    if (b.bottom <= r.top) return 'vis';

    // 4. Under folden. Maalt mot den EKTE viewporthoeyden, ikke mot den
    //    `rootMargin` har krympet, saa et element som saavidt titter fram i
    //    de nederste 8 prosentene ikke faar skjul-tilstand mens leseren ser
    //    toppkanten av det.
    var vh = document.documentElement.clientHeight || window.innerHeight || 0;
    if (b.top >= vh) return 'skjul';

    // Alt annet: null hoeyde, degenerert geometri, delvis synlig under
    // terskelen. Tvil ender i synlig.
    return 'vis';
  }

  function revealNaadd(entry) {
    var b = entry.boundingClientRect;
    var r = entry.rootBounds;
    var rotH = r ? r.height : document.documentElement.clientHeight || 0;
    var maksMulig = b.height > 0 ? Math.min(1, rotH / b.height) : 1;
    var maal = maksMulig >= REVEAL_TERSKEL ? REVEAL_TERSKEL : 0;
    return entry.intersectionRatio >= maal;
  }

  function revealRunde(entries) {
    entries.forEach(function (entry) {
      var rot = entry.target;

      // Selve tilstandsattributtet er foerste-runde-flagget. Ingen egen
      // bokfoering, og det overlever `shopify:section:load`: ny DOM betyr
      // ingen attributt, altsaa frisk klassifisering.
      if (!rot.hasAttribute('data-avslor-tilstand')) {
        if (revealKlassifiser(entry) === 'vis') {
          revealVis(rot, false);
          revealIO.unobserve(rot);
        } else {
          revealSkjul(rot);
        }
        return;
      }

      if (rot.getAttribute('data-avslor-tilstand') !== 'skjult') return;
      if (entry.isIntersecting && revealNaadd(entry)) {
        revealVis(rot, true);
        revealIO.unobserve(rot);
      }
    });
  }

  /* Revurderingen er ENVEIS: den avsloerer, den skjuler aldri.
     Ved hard reload gjenoppretter nettleseren rulleposisjonen som en del av
     lastingen. Skriptet lastes `defer`, saa `start()` kjoerer synkront paa
     `readyState === "interactive"` — tidligst mulig, altsaa verst mulig
     tidspunkt for kapploepet. Klassifiserer vi da mot toppen av siden, kan
     en gruppe bli stemplet «under folden» et oeyeblikk foer posisjonen
     havner over den.

     Bare den ene klassen trenger reparasjon: havner gruppa INNE i
     viewporten etter gjenopprettingen, er gjenopprettingen selv en scroll,
     ratio krysser terskelen, og observatoeren fyrer en ny runde. Havner den
     OVER toppen, kommer den aldri tilbake. Derfor testen `top <= 0`.

     Begge triggerne kjoerer, ikke «det som kommer foerst»: `load` fanger sen
     layout-forskyvning fra late bilder, foerste `scroll` fanger den
     leserdrevne. Begge er idempotente og koster én rect-lesing per gruppe
     som fortsatt er skjult. */
  function revealRevurder() {
    document
      .querySelectorAll('[data-skm-talg-reveal-gruppe][data-avslor-tilstand="skjult"]')
      .forEach(function (rot) {
        var rect = rot.getBoundingClientRect();
        if (rect.top > 0) return;
        // Ligger gruppa helt over toppen ser ingen animasjonen uansett.
        revealVis(rot, rect.bottom > 0);
        if (revealIO) revealIO.unobserve(rot);
      });
  }

  function revealStart() {
    // Uten IntersectionObserver skjer ingenting, og da er alt synlig.
    if (!('IntersectionObserver' in window)) return;

    // Reduced-motion: legg ALDRI paa skjul-tilstanden. Med snudd default er
    // det hele haandteringen. Merk at den universelle reseten i
    // skm-v2-tokens.css nuller varigheter, men ikke tvinger sluttilstand,
    // saa CSS alene ville ikke reddet et element som allerede laa paa 0.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (!revealIO) {
      revealIO = new IntersectionObserver(revealRunde, {
        threshold: [0, REVEAL_TERSKEL],
        rootMargin: REVEAL_MARGIN
      });
    }

    var nye = [];
    document.querySelectorAll('[data-skm-talg-reveal-gruppe]').forEach(function (rot) {
      if (rot.hasAttribute('data-avslor-tilstand')) return;
      // En lukket <dialog> rapporterer 0x0 i punkt 0,0. Veiviseren rendrer
      // produktkort, saa vakten er reell og ikke teoretisk.
      if (rot.closest('dialog')) return;
      nye.push(rot);
    });
    if (!nye.length) return;

    // DOBBEL rAF FOER `observe()`. Flytter foerste runde til etter minst én
    // malt ramme, som er der Chrome faktisk anvender gjenopprettet
    // rulleposisjon. Feilmodusen er selvsikrende: i en strupt fane kjoerer
    // `rAF` aldri, altsaa observeres ingenting, altsaa skjules ingenting.
    // Samme mekanisme som felte den gamle heroen, snudd til vaar fordel.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        nye.forEach(function (rot) {
          if (!rot.isConnected || rot.hasAttribute('data-avslor-tilstand')) return;
          revealIO.observe(rot);
        });
      });
    });
  }

  window.addEventListener('load', revealRevurder);
  window.addEventListener('scroll', revealRevurder, { once: true, passive: true });

  /* =========================================================
     Delegerte lyttere
     ========================================================= */

  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('[data-skm-talg-filter]') : null;
    if (!chip) return;
    var rot = chip.closest('[data-skm-talg-matrise]');
    if (rot) filtrer(rot, chip.getAttribute('data-skm-talg-filter'));
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;

      if (form.matches('[data-skm-talg-kjop]')) {
        e.preventDefault();
        leggIKurv(form);
        return;
      }
      if (form.matches('[data-skm-talg-varsle]') || form.matches('[data-skm-talg-epost]')) {
        e.preventDefault();
        sendEpost(form);
      }
    },
    true
  );

  function start() {
    document.querySelectorAll('[data-skm-talg-matrise]').forEach(function (rot) {
      var standard = rot.getAttribute('data-standardfilter') || 'alle';
      filtrer(rot, standard);
    });
    revealStart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
